import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { authService } from "../../services/authService";

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    authService.logout();
    navigate("/admin/login");
  };

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900">
      {/* Sidebar */}
      <aside className="fixed right-0 top-0 h-full w-64 bg-white dark:bg-slate-800 border-l border-slate-200 dark:border-slate-700 shadow-lg">
        <div className="p-6 border-b border-slate-200 dark:border-slate-700">
          <h1 className="text-xl font-bold text-[#0d171b] dark:text-white">
            لوحة التحكم
          </h1>
        </div>
        <nav className="p-4 space-y-2">
          <Link
            to="/admin/dashboard"
            className={`block px-4 py-3 rounded-lg transition ${
              isActive("/admin/dashboard")
                ? "bg-primary text-white"
                : "text-[#0d171b] dark:text-white hover:bg-slate-100 dark:hover:bg-slate-700"
            }`}
          >
            الرئيسية
          </Link>
          <Link
            to="/admin/categories"
            className={`block px-4 py-3 rounded-lg transition ${
              isActive("/admin/categories")
                ? "bg-primary text-white"
                : "text-[#0d171b] dark:text-white hover:bg-slate-100 dark:hover:bg-slate-700"
            }`}
          >
            الفئات
          </Link>
          <Link
            to="/admin/products"
            className={`block px-4 py-3 rounded-lg transition ${
              isActive("/admin/products")
                ? "bg-primary text-white"
                : "text-[#0d171b] dark:text-white hover:bg-slate-100 dark:hover:bg-slate-700"
            }`}
          >
            المنتجات
          </Link>
          <Link
            to="/admin/orders"
            className={`block px-4 py-3 rounded-lg transition ${
              isActive("/admin/orders")
                ? "bg-primary text-white"
                : "text-[#0d171b] dark:text-white hover:bg-slate-100 dark:hover:bg-slate-700"
            }`}
          >
            الطلبات
          </Link>
          <Link
            to="/admin/cms"
            className={`block px-4 py-3 rounded-lg transition ${
              isActive("/admin/cms")
                ? "bg-primary text-white"
                : "text-[#0d171b] dark:text-white hover:bg-slate-100 dark:hover:bg-slate-700"
            }`}
          >
            إدارة المحتوى
          </Link>
        </nav>
        <div className="absolute bottom-0 w-full p-4 border-t border-slate-200 dark:border-slate-700">
          <button
            onClick={handleLogout}
            className="w-full px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 transition"
          >
            تسجيل الخروج
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="mr-64 p-8">{children}</main>
    </div>
  );
};

export default AdminLayout;

